export interface GebiedStrict {
  code: string;
  naam: string;
  sedId: string; // staatkundige eenhei-d id
}

export function createGebiedStrict(gebied: Partial<GebiedStrict>): GebiedStrict {
  return {
    sedId: null,
    code: null,
    naam: null,
    ...gebied,
  };
}

export interface Gebied extends GebiedStrict {
  begindatum?: Date;
  einddatum?: Date;
  gbdId?: string;
  gbdIdOmvat?: string;
  codeEnNaam: string;
  staatkundigeEenheid?: StaatkundigeEenheid;
}

export interface StaatkundigeEenheid {
  begindatum: Date;
  certificaatNaam: string;
  code: string;
  einddatum: Date;
  externeToelichting: string;
  interneToelichting: string;
  memo: string;
  naam: string;
  sedId: string;
  taal: string;
  volledigeNaam: string;
  taalMng: string;
}
